import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/LegalDocs.css";

function LegalDocs() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  return (
    <div className="legal-section-title">
      <h1 className="legal-siteTitle">
        <Link to="/">
          Health <span className="legal-siteSign">+</span>
        </Link>
      </h1>

      <div className="legal-text-content">
        <p className="legal-title">General Info</p>
        <p className="legal-description">
          Welcome to NeuroCare Clinic, your trusted online neurology platform. Our
          mission is to provide accessible and personalized neurological services
          to individuals seeking expert neurological advice and treatment. By using
          our platform, you agree to the terms outlined in our Privacy Policy
          and Terms of Service.
        </p>

        <p className="legal-title">Privacy Policy</p>
        <p className="legal-description">
          Your privacy is paramount to us. Our Privacy Policy outlines how we
          collect, use, and protect your personal and medical information. We
          ensure secure data handling, and you can trust that your information
          is treated with the utmost confidentiality.
        </p>

        <p className="legal-title">Terms of Service</p>
        <p className="legal-description">
          When using Vijayasri Hospital, you agree to our Terms of Service. This
          includes guidelines for using our platform, interacting with doctors,
          and the responsibilities of both parties. It's essential to understand
          these terms to ensure a smooth experience for all users.
        </p>

        <p className="legal-title">Consultations</p>
        <p className="legal-description">
          Our platform connects you with expert neurologists who provide online
          consultations. These consultations are not a replacement for in-person
          neurological visits but serve as a convenient option for neurological advice,
          prescriptions, and guidance. It's crucial to provide accurate and
          complete information to receive the best possible neurological care.
        </p>

        <p className="legal-title">How it Works</p>
        <p className="legal-description">
          NeuroCare Clinic is designed to simplify neurological access. You can choose
          a neurologist, schedule an appointment, and engage in a virtual
          consultation. Our neurologists offer personalized advice and treatment
          plans tailored to your neurological needs. Please remember that neurological emergencies require
          immediate attention and should be directed to your local
          neurological facility.
        </p>
      </div>

      <div className="legal-footer">
        <p>© 2013-2023 Health+. All rights reserved.</p>
      </div>
    </div>
  );
}

export default LegalDocs;
